import { render, staticRenderFns } from "./AddModuleDetail.vue?vue&type=template&id=f76a751e&scoped=true"
import script from "./AddModuleDetail.vue?vue&type=script&lang=js"
export * from "./AddModuleDetail.vue?vue&type=script&lang=js"
import style0 from "./AddModuleDetail.vue?vue&type=style&index=0&id=f76a751e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76a751e",
  null
  
)

export default component.exports